export default __webpack_public_path__ + "static/media/leather_flap_NORM-min.8193cbbc.png";